module.exports = "/_next/static/images/FundsBanner-d1f64e49c6ecb38a97c9bc8c61ad6402.svg";